/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetTextEditorDocumentParams,
  PaginatedTextEditorDocuments,
  SchemaValidationErrorResponse,
  TextEditorDocument,
  TextEditorDocumentInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Document
 */
export const createTextEditorDocument = (
    textEditorDocumentInput: MaybeRefOrGetter<TextEditorDocumentInput>,
 signal?: AbortSignal
) => {
      textEditorDocumentInput = toValue(textEditorDocumentInput);

      return axiosClient<TextEditorDocument>(
      {url: `/text_editor/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: textEditorDocumentInput, signal
    },
      );
    }




export const getCreateTextEditorDocumentMutationKey = () => ['createTextEditorDocument'] as const;

export const getCreateTextEditorDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,CreateTextEditorDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,CreateTextEditorDocumentMutationVariables, TContext> => {

const mutationKey = getCreateTextEditorDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTextEditorDocument>>, CreateTextEditorDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTextEditorDocument(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createTextEditorDocument>>>
    export type CreateTextEditorDocumentMutationBody = TextEditorDocumentInput
    export type CreateTextEditorDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateTextEditorDocumentMutationVariables = {data: TextEditorDocumentInput}

    /**
 * @summary Create Document
 */
export const useCreateTextEditorDocument = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,CreateTextEditorDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTextEditorDocument>>,
        TError,
        CreateTextEditorDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTextEditorDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Documents
 */
export const listTextEditorDocuments = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedTextEditorDocuments>(
      {url: `/text_editor/documents`, method: 'GET', signal
    },
      );
    }




export const getListTextEditorDocumentsQueryKey = () => {
    return [
    'text_editor','documents'
    ] as const;
    }


export const getListTextEditorDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listTextEditorDocuments>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTextEditorDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTextEditorDocuments>>> = ({ signal }) => listTextEditorDocuments(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData>
}

export type ListTextEditorDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listTextEditorDocuments>>>
export type ListTextEditorDocumentsQueryError = ErrorType<void>


/**
 * @summary List of Documents
 */

export function useListTextEditorDocuments<TData = Awaited<ReturnType<typeof listTextEditorDocuments>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTextEditorDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Document
 */
export const deleteTextEditorDocument = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/text_editor/documents/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTextEditorDocumentMutationKey = () => ['deleteTextEditorDocument'] as const;

export const getDeleteTextEditorDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,DeleteTextEditorDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,DeleteTextEditorDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteTextEditorDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTextEditorDocument>>, DeleteTextEditorDocumentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteTextEditorDocument(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTextEditorDocument>>>

    export type DeleteTextEditorDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteTextEditorDocumentMutationVariables = {id: string}

    /**
 * @summary Delete Document
 */
export const useDeleteTextEditorDocument = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,DeleteTextEditorDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTextEditorDocument>>,
        TError,
        DeleteTextEditorDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTextEditorDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Document
 */
export const getTextEditorDocument = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetTextEditorDocumentParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<TextEditorDocument>(
      {url: `/text_editor/documents/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTextEditorDocumentQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetTextEditorDocumentParams>,) => {
    return [
    'text_editor','documents',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTextEditorDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getTextEditorDocument>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetTextEditorDocumentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTextEditorDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetTextEditorDocumentQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTextEditorDocument>>> = ({ signal }) => getTextEditorDocument(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTextEditorDocument>>, TError, TData>
}

export type GetTextEditorDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getTextEditorDocument>>>
export type GetTextEditorDocumentQueryError = ErrorType<void>


/**
 * @summary Get Document
 */

export function useGetTextEditorDocument<TData = Awaited<ReturnType<typeof getTextEditorDocument>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetTextEditorDocumentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTextEditorDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTextEditorDocumentQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Document
 */
export const updateTextEditorDocument = (
    id: MaybeRefOrGetter<string>,
    textEditorDocumentInput: MaybeRefOrGetter<TextEditorDocumentInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
textEditorDocumentInput = toValue(textEditorDocumentInput);

      return axiosClient<TextEditorDocument>(
      {url: `/text_editor/documents/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: textEditorDocumentInput, signal
    },
      );
    }




export const getUpdateTextEditorDocumentMutationKey = () => ['updateTextEditorDocument'] as const;

export const getUpdateTextEditorDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,UpdateTextEditorDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,UpdateTextEditorDocumentMutationVariables, TContext> => {

const mutationKey = getUpdateTextEditorDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTextEditorDocument>>, UpdateTextEditorDocumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateTextEditorDocument(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateTextEditorDocument>>>
    export type UpdateTextEditorDocumentMutationBody = TextEditorDocumentInput
    export type UpdateTextEditorDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateTextEditorDocumentMutationVariables = {id: string;data: TextEditorDocumentInput}

    /**
 * @summary Update Document
 */
export const useUpdateTextEditorDocument = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,UpdateTextEditorDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTextEditorDocument>>,
        TError,
        UpdateTextEditorDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTextEditorDocumentMutationOptions(options), queryClient);
    }
